import { useEffect, useState } from "react";
import { PenLine, CheckCircle2, AlertCircle } from "lucide-react";
import { get } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { SignatureDialog } from "./SignatureDialog";

const when = (iso) => new Date(iso).toLocaleString("en-GB", { timeZone: "Europe/London", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

const TEXT = {
  officer: { tid: "officer-signature", need: "The warrant officer needs to sign for this run.", button: "Officer signature" },
  locksmith: { tid: "locksmith-signature", need: "The locksmith needs to sign for this run.", button: "Locksmith signature" },
};

const RunSignature = ({ run, onSigned, kind }) => {
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState(null);
  const t = TEXT[kind];
  const signedAt = run[`${kind}_signed_at`];
  const signedName = run[`${kind}_signed_name`];

  useEffect(() => {
    if (signedAt) {
      get(`/runs/${run.id}/signature?kind=${kind}`).then((s) => setImage(s.image)).catch(() => setImage(null));
    }
  }, [run.id, signedAt, kind]);

  if (!run[`require_${kind}_signature`]) return null;
  return (
    <div className={`mt-4 rounded-lg border p-4 ${signedAt ? "border-emerald-200 bg-emerald-50" : "border-amber-200 bg-amber-50"}`} data-testid={`${t.tid}-card`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-start gap-2 text-sm">
          {signedAt ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" /> : <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-700" />}
          <span className={signedAt ? "text-emerald-900" : "text-amber-900"} data-testid={`${t.tid}-status`}>
            {signedAt ? <>{t.button}: signed by <strong>{signedName}</strong> on {when(signedAt)}</> : <><strong>Signature needed.</strong> {t.need}</>}
          </span>
        </div>
        <Button onClick={() => setOpen(true)} variant={signedAt ? "outline" : "default"} className={signedAt ? "bg-white" : "bg-blue-700 hover:bg-blue-800"} data-testid={`${t.tid}-button`}>
          <PenLine className="mr-2 h-4 w-4" /> {signedAt ? "Sign again" : t.button}
        </Button>
      </div>
      {signedAt && image && <img src={image} alt={`Signature of ${signedName}`} className="mt-3 h-24 w-auto rounded border border-emerald-200 bg-white p-1" data-testid={`${t.tid}-image`} />}
      <SignatureDialog open={open} onOpenChange={setOpen} run={run} onSigned={onSigned} kind={kind} />
    </div>
  );
};

export const OfficerSignature = ({ run, onSigned }) => (
  <>
    <RunSignature run={run} onSigned={onSigned} kind="officer" />
    <RunSignature run={run} onSigned={onSigned} kind="locksmith" />
  </>
);
